"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(value, startPos) {
  var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var pos = startPos;

  while (value.length > pos) {
    if (/\d/.test(value[pos])) return pos;
    pos += direction;
  }

  return -1;
}